import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { DynamicScriptLoaderServiceService } from '../../_services/dynamic-script-loader-service.service';
import { AuthenicationService } from '../../_services/authenication.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  userdetaild: string;

  // tslint:disable-next-line:max-line-length
  constructor( private dynamicScriptLoader: DynamicScriptLoaderServiceService, private authenicationService: AuthenicationService, private router: Router ) { }

  ngOnInit() {
    DynamicScriptLoaderServiceService.loadDynamicLinks('assets/assets/plugins/jquery-ui-1.12.1/jquery-ui.min.css');
    // DynamicScriptLoaderServiceService.adminScripts();
    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/dist/js/custom.js');
    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/dist/js/mycustom.js');

    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'patient') {
      this.authenicationService.logout();
      this.router.navigateByUrl('/login');
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'doctor') {
      this.authenicationService.logout();
      this.router.navigateByUrl('/login');
    }
    
    // if (!this.userdetaild || this.userdetaild['users_usertype'] == 'admin') {
    //   this.router.navigateByUrl('/doctor-dashboard');
    // }
   // console.log(this.userdetaild);
  }


}
